export const generalConsultDetailConstants = {
  filiationData: {
    heading: 'Datos de Filiación',
    help: 'Completa la información de los datos de filiación en la versión del informante'
  },
  subject: {
    heading: 'Motivo de Consulta',
    help: 'Anotar la causa del problema en la versión del informante'
  },
  disease: {
    heading: 'Enfermedad Actual',
    help: 'Cronología, localización, características, intensidad, causa aparente, '
    + 'factores que agravan o mejoran, síntomas asociados, evolución, medicamentos '
    + 'que recibe, resultados de exámenes anteriores, condición actual'
  },
  analysis: {
    heading: 'Análisis',
    help: ''
  },
  additionalInformation: {
    heading: 'Exámenes Complementarios',
    help: 'Información adicional de la consulta'
  },
  treatmentPlan: {
    heading: 'Planes Tratamiento y Educacionales'
  }
};
